import { Options, Splide } from '@splidejs/splide'

import { isTabletWideDown, mediaQueries } from '../Utility/Breakpoint'
import { getElementChild, getElements } from '../Utility/Dom'

class ProfessionalDevelopmentSlider {
  private slider: null | Splide = null
  private readonly sliderElement: HTMLElement | null
  private sliderMounted = false

  constructor(container: HTMLElement) {
    this.sliderElement = getElementChild(container, 'professional-development-slider')
  }

  public init(): void {
    if (this.sliderElement === null) {
      return
    }

    this.toggleSlider(isTabletWideDown())

    mediaQueries.tabletWide.down.addEventListener('change', (event: MediaQueryListEvent): void => {
      this.toggleSlider(event.matches)
    })
  }

  private addSlideClasses(): void {
    if (this.sliderElement === null) {
      return
    }

    const items = this.sliderElement.querySelectorAll('.splide__list > li')

    items.forEach((item: Element): void => {
      item.classList.add('splide__slide')
    })
  }

  private getSliderOptions(): Options {
    return {
      arrows: true,
      /* eslint-disable perfectionist/sort-objects -- splide requires descending breakpoint order */
      breakpoints: {
        1024: {
          perPage: 2,
        },
        768: {
          pagination: false,
          perPage: 2,
        },
        575: {
          focus: 'center',
          gap: '1rem',
          pagination: false,
          perPage: 1.1,
        },
      },
      /* eslint-enable perfectionist/sort-objects */
      gap: '1.25rem',
      omitEnd: true,
      perMove: 1,
      perPage: 3,
      type: 'slide',
    }
  }

  private removeSlideClasses(): void {
    if (this.sliderElement === null) {
      return
    }

    const items = this.sliderElement.querySelectorAll('.splide__list > li')

    items.forEach((item: Element): void => {
      item.classList.remove('splide__slide')
    })
  }

  private toggleSlider(isActive: boolean): void {
    if (this.sliderElement === null) {
      return
    }

    const itemCount = this.sliderElement.querySelectorAll('.splide__list > li').length
    const shouldMount = (isActive === true && itemCount > 1) || itemCount > 3

    if (shouldMount === true && this.sliderMounted === false) {
      this.addSlideClasses()
      this.slider = new Splide(this.sliderElement, this.getSliderOptions())
      this.slider.mount()
      this.slider.refresh()
      this.sliderMounted = true
    } else if (shouldMount === false && this.sliderMounted === true && this.slider !== null) {
      this.slider.destroy(true)
      this.slider = null
      this.sliderMounted = false
      this.removeSlideClasses()
      this.sliderElement.classList.remove('is-initialized')
    }
  }
}

const containers = getElements('professional-development-list')

containers.forEach((container: HTMLElement): void => {
  const slider = new ProfessionalDevelopmentSlider(container)
  slider.init()
})
